<!--
 * @Author: Lemon C
 * @Date: 2024-12-14 13:51:47
 * @LastEditTime: 2025-11-14 13:10:22
-->
<template>
    <div class="sup-video-dialog" v-if="dialog_visible">
        <div class="cancel-box" @click="bg_click">
            <img src="@/assets/imgs/general/icon_cancel.png" />
        </div>
        <transition name="content_box_fade">
            <div class="content-box" v-if="content_box_visible" @click.stop>
                <video id="id-video" class="video-box" autoplay loop muted controls>
                    <source :src="video_urlPath_computed" type="video/mp4" />
                    <source :src="video_urlPath_computed" type="video/webm" />
                    <source :src="video_urlPath_computed" type="video/ogg" />
                </video>
            </div>
        </transition>
    </div>
</template>

// MOD-- JavaScript
<script setup>
import { ref, nextTick, watch, computed } from 'vue';
import { useDialogStore } from '@/stores/dialog';

const dialog_store = useDialogStore();

const dialog_visible = ref(false);
const content_box_visible = ref(false);
const vedio_path = ref('');

watch([() => vedio_path.value], () => {
    const videoElement = document.getElementById('id-video');
    if (videoElement) {
        videoElement.load();
    }
});

const video_urlPath_computed = computed(() => {
    // return `${window.downloadBaseUrl}/${product_video.value.path}?v=1`;
    if (vedio_path.value.includes(window.downloadBaseUrl)) {
        return vedio_path.value;
    } else {
        return `${window.downloadBaseUrl}/${vedio_path.value}`;
    }
});

// MARK Click 底部点击
const bg_click = () => {
    dialog_store.hideVideoDialog();
};

// MARK Expose 隐藏
const show_dialog = (vedioPath) => {
    // console.log('vedioPath: ', vedioPath);
    vedio_path.value = vedioPath;
    dialog_visible.value = true;
    nextTick(() => {
        content_box_visible.value = true;
    });
};

// MARK Expose 隐藏
const hide_dialog = () => {
    content_box_visible.value = false;
    setTimeout(() => {
        dialog_visible.value = false;
    }, 200);
};

// MARK Expose 导出方法
defineExpose({
    show_dialog,
    hide_dialog,
});
</script>

// MOD-- CSS
<style lang="less" scoped>
.sup-video-dialog {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: var(--color-main-dark-bg);
    z-index: var(--dialog-z-index);
    display: flex;
    justify-content: center;
    align-items: center;
    overflow-y: auto;

    .cancel-box {
        position: absolute;
        top: 10px;
        right: 20px;
        width: 40px;
        height: 40px;
        color: var(--color-main-text-dark-bg-primary);
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;

        img {
            width: 100%;
            height: 100%;
        }
    }

    .content-box {
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        height: 90%;
        aspect-ratio: 16 / 9;
        flex-shrink: 0;
        border-radius: 8px;
        padding: 5px;
        box-sizing: border-box;
        transition: opacity 0.5s ease-in-out;
        z-index: var(--dialog-z-index);
        background-color: var(--color-main-light-bg-white);

        .video-box {
            position: relative;
            background-color: var(--color-main-dark-transparent-bg);
            width: 100%;
            height: 100%;
            border-radius: 8px;
            overflow: hidden;
        }
    }
}

.content_box_fade-enter-active,
.content_box_fade-leave-active {
    transition: opacity 0.5s;
}

.content_box_fade-enter-from,
.content_box_fade-leave-to {
    opacity: 0;
}
</style>
